import React from "react"
import { AtribuirRegiaoContextProvider } from "./context/AtribuirRegiaoContextProvider"
import { AtribuirRegiao } from "./AtribuirRegiao"

export function Index() {
    return (
        <AtribuirRegiaoContextProvider>
            <AtribuirRegiao />
        </AtribuirRegiaoContextProvider>
    )
}
